import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../examples/Navbars/DashboardNavbar";
import { useEffect, useState } from 'react';
import { TextField, Button, MenuItem } from '@material-ui/core';
import { useLocation, useNavigate } from "react-router-dom";
import { isExpired } from "react-jwt";
import { Alert, Snackbar } from "@mui/material";
import { ReAuth } from "layouts/authentication/reAuth";
import { verifyRolesAcess } from "../../../services/Utils/verifyRolesAcess";
import planoService from '../../../services/PlanoService';

function CadPlanos() {
  const [valor, setValor] = useState('0,00');
  const [descricao, setDescricao] = useState('');
  const [alertError, setAlertError] = useState(false);
  const [msgError, setMsgError] = useState('');
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [msgSuccess, setMsgSuccess] = useState('');
  const [tokenExpired, setTokenExpired] = useState(false);
  const [invalidPermission, setInvalidPermission] = useState(false);
  const [tipoCobranca, setTipoCobranca] = useState('Mensal');
  const [frequenciaDias, setFrequenciaDias] = useState(1);
  const [duracao, setDuracao] = useState(1);
  const [errorDescricao, setErrorDescricao] = useState(false);
  const [errorValor, setErrorValor] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idPlano = queryParams.get('id');

  const handleReAuthInfo = () => {
    setTokenExpired(isExpired(localStorage.getItem('token')));
  };

  useEffect(() => {
    setErrorDescricao(false);
  }, [descricao]);

  useEffect(() => {
    setErrorValor(false);
  }, [valor]);

  useEffect(() => {
    async function init() {
      const perm = await verifyRolesAcess('funcionarios');
      setInvalidPermission(!perm);
      setTokenExpired(isExpired(localStorage.getItem('token')));

      if (idPlano != null) {
        try {
          const result = await planoService.getByID(idPlano);
          console.log('[CadPlanos] plano carregado:', JSON.stringify(result.data));
          setDescricao(result.data.descricao);
          setValor(result.data.valor.toString().replace('.', ','));
          setTipoCobranca(result.data.tipoCobranca || 'Mensal');
          setFrequenciaDias(result.data.frequenciaDias || 1);
          setDuracao(result.data.duracao || 1);
        } catch (e) { console.error('Erro ao carregar plano:', e); }
      }
    }
    init();
  }, []);

  const handleSubmit = async () => {
    let valid = true;

    if (!descricao || descricao.trim() === '') {
      setErrorDescricao(true);
      valid = false;
    }

    let valorNumerico = parseFloat(valor.toString().replace(',', '.'));
    if (isNaN(valorNumerico) || valorNumerico < 0) {
      setErrorValor(true);
      valid = false;
    }

    if (!valid) return;

    const objPlano = {
      Descricao: descricao,
      FrequenciaDias: frequenciaDias,
      Duracao: duracao,
      Valor: valorNumerico,
      TipoCobranca: tipoCobranca,
      Ativo: true
    };

    console.log('[CadPlanos] payload PUT/POST:', JSON.stringify(objPlano));

    if (idPlano != null) {
      objPlano.Id = idPlano;
      planoService.putPlano(objPlano, idPlano)
        .then((result) => {
          setAlertSuccess(true);
          setMsgSuccess(result.data.mensagemRetorno);
        })
        .catch((error) => {
          setAlertError(true);
          setMsgError(error.response?.data?.mensagemRetorno || 'Erro ao atualizar plano.');
        });
    } else {
      planoService.postPlano(objPlano)
        .then((result) => {
          setAlertSuccess(true);
          setMsgSuccess(result.data.mensagemRetorno);
        })
        .catch((error) => {
          setAlertError(true);
          setMsgError(error.response?.data?.mensagemRetorno || 'Erro ao cadastrar plano.');
        });
    }
  };

  const handleCloseSnak = () => {
    setTimeout(() => {
      setDescricao('');
      setValor('0,00');
      setAlertError(false);
      setAlertSuccess(false);
      navigate('/planos');
    }, 1200);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {alertSuccess && (
        <Snackbar open autoHideDuration={1500} onClose={handleCloseSnak}>
          <Alert onClose={handleCloseSnak} severity="success" sx={{ width: '100%' }}>
            {msgSuccess}
          </Alert>
        </Snackbar>
      )}

      {tokenExpired ? (
        <ReAuth handleAuth={handleReAuthInfo} />
      ) : (
        <>
          {invalidPermission ? (
            <Alert severity="error">Você não tem permissão para acessar esse recurso.</Alert>
          ) : (
            <MDBox pt={6} pb={3}>
              <Grid container spacing={6}>
                <Grid item xs={12}>
                  <Card>
                    <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                      <MDTypography variant="h6" color="white">
                        {idPlano ? 'Editar Plano' : 'Novo Plano'}
                      </MDTypography>
                    </MDBox>

                    <Grid container spacing={3} p={4}>
                      <Grid item xs={12}>
                        <TextField
                          label="Descrição"
                          value={descricao}
                          onChange={(e) => setDescricao(e.target.value)}
                          fullWidth
                          required
                        />
                        {errorDescricao && (
                          <Alert severity="error" sx={{ mt: 1 }}>
                            Informe a descrição do plano.
                          </Alert>
                        )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Valor (R$)"
                          value={valor}
                          onChange={(e) => {
                            const v = e.target.value.replace(/[^0-9,]/g, '');
                            setValor(v);
                          }}
                          fullWidth
                          required
                          type="text"
                        />
                        {errorValor && (
                          <Alert severity="error" sx={{ mt: 1 }}>
                            Informe um valor válido.
                          </Alert>
                        )}
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Tipo de Cobrança"
                          value={tipoCobranca}
                          onChange={(e) => setTipoCobranca(e.target.value)}
                          select
                          fullWidth
                          required
                        >
                          <MenuItem value="Mensal">Mensal</MenuItem>
                          <MenuItem value="Anual">Anual</MenuItem>
                          <MenuItem value="Ilimitado">Ilimitado</MenuItem>
                          <MenuItem value="Sessao">Sessão</MenuItem>
                        </TextField>
                      </Grid>

                      <Grid item xs={12} pt={4}>
                        <Button variant="contained" color="primary" fullWidth onClick={handleSubmit}
                          style={{ backgroundColor: '#7b0b99' }}>
                          Salvar
                        </Button>
                      </Grid>

                      {alertError && (
                        <Grid item xs={12}>
                          <Alert severity="error" action={
                            <Button color="inherit" size="small" onClick={() => { setAlertError(false); setMsgError(''); }}>
                              OK
                            </Button>
                          }>
                            {msgError}
                          </Alert>
                        </Grid>
                      )}
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          )}
        </>
      )}
    </DashboardLayout>
  );
}

export default CadPlanos;
